import React from 'react';

const CollectionPrivate = () => (
  <div className="profile container page-container">
    <div className="container is-narrow">
      <div className="card has-background-dark mt-4">
        <div className="card-content has-text-white">
          <h2 className="title is-size-2 has-text-white has-text-centered">
            Sorry, this collection is private and cannot be viewed.
          </h2>
        </div>
      </div>
    </div>
  </div>
);

export default CollectionPrivate;
